import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";

const SvgSparklePointerIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    fill="none"
    viewBox="0 0 21 21"
    ref={ref}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6 1L6.8 3.9M3.9 6.8L1 6M12.8 2.9L10.8 4.8M4.8 10.8L2.9 12.8M7.8 7.8L12.8 19.8L14.6 14.6L19.8 12.8L7.8 7.8Z"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgSparklePointerIcon);
const Memo = memo(ForwardRef);
export default Memo;
